module.exports = ".text-link {\n  color: var(--xiobit-transparent-white-color); }\n"